var map = {
	"./webDiscountBuypoint.vue": [
		7203,
		7429
	],
	"./webDiscountInfo.vue": [
		3259,
		1403
	],
	"./webDiscountUsepoint.vue": [
		6751,
		2614
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1454;
module.exports = webpackAsyncContext;